import { ErrorFallback } from '@pages/error-fallback';
import { ErrorBoundary } from '@sentry/react';
import { Outlet } from 'react-router-dom';
import { Suspense } from '@core/suspense';
import { FC } from 'react';

import { useProtectedRoute } from './use-protected-route';

export const ProtectedRoute: FC = () => {
  const { isLoading, isError } = useProtectedRoute();

  if (isLoading || isError) {
    return <Suspense />;
  }

  return (
    <ErrorBoundary
      fallback={({ error, componentStack, eventId }) => (
        <ErrorFallback
          componentStack={componentStack}
          error={error as Error}
          eventId={eventId}
          type="route"
        />
      )}
    >
      <Outlet />
    </ErrorBoundary>
  );
};
